import axios from 'axios'
import globals from './globals'

const token = window.localStorage.getItem('token')
// const apiurl = 'https://beta.charthur.com:3035'
const apiurl = '/api'

const header = {
  headers: {
    'Authorization': `Bearer ${token}`
  }
}

// Login
const login = form => {
  return axios.post(`${apiurl}/login`, form)
}

const logout = () => {
  return axios.get(`${apiurl}/logout`, header)
}

// Entries
const fetchEntries = () => {
  console.log('wakawaka', apiurl)
  return axios.get(`${apiurl}/entries`, header)
}

const searchEntries = search => {
  const encodedSearch = encodeURIComponent(search)
  return axios.get(`${apiurl}/search/${encodedSearch}`, header)
}

const saveEntry = entry => {
  return axios.post(`${apiurl}/entry`, entry, header)
}

const deleteEntry = guid => {
  console.log('delete axios')
  return axios.delete(`${apiurl}/entry/${guid}`, header)
}

// Tags
const fetchMeasurementsByTag = tag => {
  return axios.get(`${apiurl}/tag/${tag}`, header)
}

// Measurements
const fetchMeasurements = () => {
  return axios.get(`${apiurl}/measurements`, header)
}

export {
  fetchEntries,
  searchEntries,
  saveEntry,
  deleteEntry,
  fetchMeasurements,
  fetchMeasurementsByTag,
  login,
  logout
}
